// extracted by mini-css-extract-plugin
module.exports = {"toolbar":"QuoteList-module_toolbar_29BJt","formGroup":"QuoteList-module_formGroup_39TKt","button":"QuoteList-module_button_12OBt"};